<canvas width="1136" height="640" class="img-fluid" #panelCanvas></canvas>